// Forcage du montant remboursable AMO (« part AMO ») d'une prestation, + taux
// d'abattement pour les actes IK. Port web de frmInfosCompPresta.vb.
//
// Reference legacy : F:\SV\PROJETDOTNET\TransCAM_Interface\frmInfosCompPresta.vb
// Structure back   : F:\SV\PROJETDOTNET\TransCAM_Library\Strfse.cs
//   (struct prestation_facturee, l.280-366)
//
// Tout le detail est natif sur chaque entree facfse.Prest[i] (cf memoire
// facfse-forme-prest-pascalcase) : Wprest/WprestCCAM arrivent nulles cote web ->
// on travaille directement sur Prest[i]. Forcage part AMO = Donneeforcee[4],
// montant force = Rembamo. Serialisation PascalCase 1re lettre.

function num(v) {
    if (v == null) return 0;
    const x = parseFloat(String(v).replace(',', '.'));
    return isNaN(x) ? 0 : x;
}
function s(v) { return v == null ? '' : String(v).trim(); }

// Arrondi 2 decimales (equivalent arrondi1_lib du legacy).
export function arrondi(n) { return Math.round((num(n) + Number.EPSILON) * 100) / 100; }

// Options du taux d'abattement (cbTauxAbat : 0 / 50 / 100 %).
export const TAUX_ABAT_OPTIONS = [
    { valeur: 0, libelle: '0 %' },
    { valeur: 50, libelle: '50 %' },
    { valeur: 100, libelle: '100 %' },
];

// Acte kilometrique (IK / ID) : le taux d'abattement n'est propose que pour ces
// actes (et, dans le legacy, specialites 24/86 ; cf estAbattementVisible).
export function estActeIK(code) { return /IK|ID/.test(s(code).toUpperCase()); }

// Visibilite du taux d'abattement : acte IK + specialite 24 ou 86 (auxiliaires).
// specialite peut etre vide cote web (carte CPS non lue) -> saisie permissive.
export function estAbattementVisible(code, specialite) {
    if (!estActeIK(code)) return false;
    const sp = s(specialite);
    return sp === '' || sp === '24' || sp === '86';
}

// Accesseur defensif d'une entree Prest (gere Prest/prest + index back).
export function getPrest(facfse, backIndex) {
    if (!facfse || backIndex == null) return null;
    const arr = Array.isArray(facfse.Prest) ? facfse.Prest
        : (Array.isArray(facfse.prest) ? facfse.prest : null);
    if (!arr) return null;
    return arr[backIndex] || null;
}

function donneeforceeDe(prest) {
    const df = (prest && Array.isArray(prest.Donneeforcee)) ? prest.Donneeforcee
        : (prest && Array.isArray(prest.donneeforcee) ? prest.donneeforcee : []);
    return df;
}

// Liste des forcages textuels d'une prestation (NGAP ou CCAM), 1-based dans le
// legacy (ForcageacteNGAP[1..Nb] / ForcageCCAM[1..Nb]).
function forcagesDe(prest, type) {
    const arr = type === 'CCAM'
        ? (prest.ForcageCCAM || prest.forcageCCAM)
        : (prest.ForcageacteNGAP || prest.forcageacteNGAP);
    if (!Array.isArray(arr)) return [];
    return arr.map((x) => s(x)).filter((x) => x !== '');
}

// Lecture : Prest[i] -> objet d'affichage (equivalent lbInfos + part AMO).
export function infosPartAMO(prest) {
    const type = (prest && prest.PrestaCCAM) ? 'CCAM' : 'NGAP';
    if (!prest) {
        return { type, code: '', baseRemb: 0, tauxRemb: 0, mtm: 0,
            partAMOCalc: 0, partAMOForce: false, partAMONew: 0,
            forcages: [], tauxAbat: 0 };
    }
    const baseRemb = num(prest.Baseremb ?? prest.baseremb);
    const tauxRemb = num(prest.Tauxremb ?? prest.tauxremb);
    const mtm = num(prest.Mtm ?? prest.mtm);
    const df = donneeforceeDe(prest);

    // Part AMO calculee = arrondi(base * taux / 100) - arrondi(MTM).
    const partAMOCalc = arrondi(baseRemb * tauxRemb / 100) - arrondi(mtm);
    const partAMOForce = !!df[4];
    const partAMONew = arrondi(num(prest.Rembamo ?? prest.rembamo));

    const infos = {
        type,
        code: type === 'CCAM' ? s(prest.Actedetail ?? prest.actedetail) : s(prest.Presta_Renamed ?? prest.presta_Renamed),
        baseRemb, tauxRemb, mtm,
        partAMOCalc: arrondi(partAMOCalc),
        partAMOForce,
        partAMONew,
        forcages: forcagesDe(prest, type),
        tauxAbat: num(prest.Tauxabat ?? prest.tauxabat),
    };

    if (type === 'CCAM') {
        infos.baserembthAMO = num(prest.BaserembthAMO ?? prest.baserembthAMO);
        infos.baserembhorsforfait = num(prest.Baserembhorsforfait ?? prest.baserembhorsforfait);
        infos.montantpersonnel = num(prest.Montantpersonnelpresta ?? prest.montantpersonnelpresta);
        infos.prixunitaire = num(prest.Prixunitaire ?? prest.prixunitaire);
        infos.donneeforcee = {
            justif: !!df[0], montant: !!df[1], base: !!df[2], pu: !!df[3], partAMO: !!df[4],
        };
    }
    return infos;
}

// Ecriture : applique le forcage du montant remboursable AMO (+ taux abattement
// pour les IK) sur Prest[i]. Mutation directe ; l'appelant fournit une copie
// defensive du facfse avant setFacfse.
//
// NB : la recomputation monetaire liee a l'abattement (base remb / montant paye)
// est faite cote backend lors du recalcul/enregistrement (fonctions rembkilom1 /
// calculbaserembthAMO_NGAP non disponibles cote web). On se limite ici a poser
// Tauxabat + Qualifdep, et a forcer Rembamo / Donneeforcee[4].
export function appliquerPartAMO(prest, { forcer, montant, tauxAbat, abatVisible }) {
    if (!prest) return;
    // garantit un tableau Donneeforcee exploitable (PascalCase).
    let df = prest.Donneeforcee;
    if (!Array.isArray(df)) { df = [false, false, false, false, false, false]; prest.Donneeforcee = df; }
    while (df.length < 6) df.push(false);

    df[4] = !!forcer;
    if (forcer) {
        prest.Rembamo = arrondi(montant);
    }

    if (abatVisible) {
        const tx = num(tauxAbat);
        prest.Tauxabat = tx;
        // Acte gratuit a 100 % -> qualif depense "G" (cf legacy) ; on retire le G
        // si on repasse en dessous de 100 et qu'il etait pose.
        const q = s(prest.Qualifdep ?? prest.qualifdep);
        if (tx === 100) prest.Qualifdep = 'G';
        else if (q === 'G') prest.Qualifdep = '';
    }
}
